// Inside service pages are /services/<type>_<product>_<installation_id> (see Inside's serviceSlug)
// The <type> part is only a label in Inside; it looks the service up by <product> + <installation_id>
const INSIDE_SERVICE: Record<string, { type: string; product: string }> = {
  bess: { type: 'flex', product: 'bess' },
  'pv curtailment': { type: 'flex', product: 'pvcurtailment' },
  'e-boiler': { type: 'flex', product: 'eboiler' },
  injection: { type: 'commodity', product: 'injection' },
  offtake: { type: 'commodity', product: 'offtake' },
};

export const insideServiceUrl = (service: { service_type: string; installation_id: string }): string => {
  const target = INSIDE_SERVICE[service.service_type.toLowerCase()];
  if (!target) return '#';
  return `${import.meta.env.VITE_INSIDE}/${target.type}_${target.product}_${service.installation_id}`;
};
